export interface ReadReceiptProps {
  /** Pre-composed, e.g. "Read by Nick, Florence" — the caller owns the pluralised i18n key. */
  children: string;
}

/**
 * Sits under the last own message the other side has already seen. Once per thread, not once per
 * message: repeating it on every bubble says nothing extra and turns a conversation into a ledger.
 */
export function ReadReceipt({ children }: ReadReceiptProps) {
  return <p className="px-1 text-neutral-400 text-xs">{children}</p>;
}
